import React, { useEffect, useMemo } from 'react';
import { Menubar } from "primereact/menubar";
import "./navBar.css";
import { classNames } from "primereact/utils";
import { useQuery } from 'react-query';
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { SplitButton } from "primereact/splitbutton";
import {
  FaSignOutAlt,
  FaInfoCircle,
  FaUsers,
  FaBuilding,
  FaCog
} from "react-icons/fa";

import { useActif } from '../../Context/ActifContext';
import fetchActifByClient from '../../Data/actif_service';
import { baseURL } from "../../api";
import { useUser } from "../../Context/UserContext";
import { useClient } from "../../Context/ClientContext"; 
import fetchUserData from "../../Data/user_service";
import fetchClientByUser from "../../Data/client_service";
import { Button } from 'primereact/button';

export const adminUser = (tab, client) => {
  const result = tab?.find((cU) => cU.id_client_gexpertise === client && cU.role === "utilisateur");
  return result;
};

export const isGexMemeber = (user) => {
  return user.is_gex_memeber;
}

export const ContactAdmin = (user) => {
  if (user.email === "n.benamor@gexpertise.fr" || user.email === "contact-gexonline@gestion.gexpertise.fr") 
    return true;
}

export const canAccessArchivedClients = (user, clientTableau, selectedClient) => {
  if (ContactAdmin(user) || isGexMemeber(user)) {
    return true;
  }
  
  const userRole = clientTableau?.find((cU) => 
    cU.id_client_gexpertise === selectedClient && 
    cU.role && 
    !['utilisateur', 'Invité'].includes(cU.role)
  );
  
  return !!userRole;
};

export default function NavBar({ setVisible }) {
  const { user, setUserAttributes } = useUser();
  const { client, setClientAttributes, selectedClient, setSelectedClient } = useClient();
  const navigate = useNavigate();
  const { setActifAttributes } = useActif();

  useQuery('userData', () => fetchUserData(setUserAttributes));
  useQuery('clientData', () => fetchClientByUser(setClientAttributes, setSelectedClient), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    keepPreviousData: true,
  });

  const clientTableau = Object.values(client);
  const uniqueClients = clientTableau.reduce((acc, curr) => {
    if (!acc.some((item) => item.id_client_gexpertise === curr.id_client_gexpertise)) {
      acc.push(curr);
    }
    return acc;
  }, []);

  // Filtrer les clients selon les permissions de l'utilisateur
  const getFilteredClients = () => {
    if (ContactAdmin(user) || isGexMemeber(user)) {
      return uniqueClients;
    }

    return uniqueClients.filter(clientItem => {
      if (!clientItem.archive || clientItem.archive !== 'True') {
        return true;
      }

      const userRole = clientTableau?.find((cU) => 
        cU.id_client_gexpertise === clientItem.id_client_gexpertise && 
        cU.role && 
        !['utilisateur', 'Invité'].includes(cU.role)
      );

      return !!userRole;
    });
  };

  const filteredClients = useMemo(() => getFilteredClients(), [uniqueClients, user]);
  
  const ClientTable = filteredClients.map((value) => ({
    name: value.nom,
    value: value.id_client_gexpertise,
    archive: value.archive,
  }));

  // CORRECTION : Vérifier et corriger le selectedClient si nécessaire
  useEffect(() => {
    if (ClientTable.length > 0 && selectedClient) {
      // Vérifier si le client sélectionné est dans la liste filtrée
      const isSelectedClientAvailable = ClientTable.some(
        c => c.value === selectedClient
      );

      // Si le client sélectionné n'est pas disponible (archivé), sélectionner le premier client disponible
      if (!isSelectedClientAvailable) {
        const firstAvailableClient = ClientTable[0].value;
        setSelectedClient(firstAvailableClient);
        localStorage.setItem("selectedClient", JSON.stringify(firstAvailableClient));
      }
    } else if (ClientTable.length > 0 && !selectedClient) {
      // Si aucun client n'est sélectionné, sélectionner le premier par défaut
      const firstClient = ClientTable[0].value;
      setSelectedClient(firstClient);
      localStorage.setItem("selectedClient", JSON.stringify(firstClient));
    }
  }, [ClientTable, selectedClient, setSelectedClient]);

  const { refetch, isFetching, data } = useQuery(
    ['actifData', selectedClient],
    () => fetchActifByClient(setActifAttributes, selectedClient),
    {
      enabled: !!selectedClient,
      keepPreviousData: false,
      staleTime: 0,
    }
  );

  useEffect(() => {
    if (selectedClient) refetch();
  }, [selectedClient, refetch]);

  let items = [
    {
      label: "Profil",
      icon: (
        <FaInfoCircle style={{ width: "17", height: "17", color: "#970121" }} />
      ),
      command: () => {
        navigate("/profil");
      }, 
    },
    {
      label: "Utilisateurs",
      icon: <FaUsers style={{ width: "17", height: "17", color: "#970121" }} />,
      command: () => {
        navigate("/utilisateurs");
      },
    },
    {
      label: "Configuration Système",
      icon: <FaCog style={{ width: "17", height: "17", color: "#970121" }} />,
      command: () => {
        navigate("/gestion");
      },
    },
    {
      separator: true,
    },
    {
      label: "Déconnexion",
      icon: (
        <FaSignOutAlt style={{ width: "17", height: "17", color: "#970121" }} />
      ),
      command: () => {
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
        window.location.reload();
      },
    },
  ];
 
  if (!adminUser(clientTableau, selectedClient)) { 
    if (!isGexMemeber(user)) {
      items = items.filter(item => item.label !== "Utilisateurs");
    }
  }
  
  if (!ContactAdmin(user)) { 
    items = items.filter(item => item.label !== "Configuration Système");
  }

  const NomClient = (ClientTable) => {
    return (
      <div className={classNames({"NomClient": archiveClient(ClientTable)})}>
        {ClientTable.name} id: {ClientTable.value}
      </div>
    );
  }

  const archiveClient = (ClientTable) => {
    if (ClientTable.archive === 'True') {
      return {
        "NomClient": true,
      };
    }
  }

  // Trouver le nom du client sélectionné pour l'affichage
  const getSelectedClientName = () => {
    const selected = ClientTable.find(c => c.value === selectedClient);
    return selected ? selected.name : "";
  };

  const end = () => {
    return (
      <div className="profile-clients">
        <FaBuilding
          style={{
            marginTop: "1%",
            position: "relative",
            height: "27",
            width: "50",
          }}
        />
        { 
          Object.keys(client).length > 1 ? 
            (isGexMemeber(user) ?
              <Dropdown
                value={selectedClient}
                options={ClientTable}
                onChange={(e) => {
                  setSelectedClient(e.value); 
                  localStorage.setItem("selectedClient", JSON.stringify(e.value));
                  navigate("/carte", { replace: true });
                }}
                optionLabel={NomClient}
                optionValue="value"
                placeholder={getSelectedClientName()}
                filter
                filterBy="name"
              /> 
              : 
              <Dropdown
                value={selectedClient}
                options={ClientTable}
                onChange={(e) => {
                  setSelectedClient(e.value);
                  localStorage.setItem("selectedClient", JSON.stringify(e.value));
                }}
                optionLabel="name"
                optionValue="value"
                placeholder={getSelectedClientName()}
                filter
                filterBy="name"
              />
            )
          : Object.keys(client).length === 1 ? 
            <h6 style={{fontWeight:'400'}}>{client[0].nom}</h6> 
            : <></>
        }
       
        <img
          src={user.photo ? baseURL + user.photo : "../../fa-user-circle.png"}
          alt="userphoto"
          className='photoUserNavbar'
        />
        <h6 
          style={{wordWrap:"break-word", wordBreak:"break-word", fontSize:"12px"}}  
          className="NameLastName"
        >
          {user.prenom} {user.nom} 
        </h6>
        <SplitButton model={items} />
      </div>
    );
  };

  const searchBox = (
    <Button icon="pi pi-list" onClick={() => setVisible(true)} className="btn-sidebar"/>
  );

  return (
    <div> 
      <div className="card">
        {<Menubar start={searchBox} end={end} className="menu-profil" />}
      </div>    
    </div>
  );
}
